module.exports = __webpack_public_path__ + "static/media/avatars_female_9.c71091db.png";